import axios from 'axios'
import store from '../store/index'

export const HTTP = axios.create({
  baseURL: `https://www.firestopdoc.com/api/v1/`,
  //baseURL: `http://localhost:5000/api/v1/`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

HTTP.interceptors.request.use(
  async config => {
    const bearerToken = store.getters.bearerToken

    if (config.url != 'account/login' && bearerToken) {
      if (!waitingForserverResonse) {
        await checkBearerIsValid(bearerToken)
      }
      config.headers.Authorization = `Bearer ${bearerToken}`
    }

    return config
  },
  err => {
    console.warn(err)
    return Promise.reject(err)
  }
)

HTTP.interceptors.response.use(
  response => {
    return response
  },
  err => {
    console.warn('my errorcode: ', err)
    if (err.response.status === 401) {
      store.dispatch('validateSession')
    }
    if (err.response.status === 400) {
      return err.response
    }
    return Promise.reject(err)
  }
)

let waitingForserverResonse = false

async function checkBearerIsValid(bearerToken) {
  waitingForserverResonse = true
  const bearerExpirationTime = store.getters.bearerExpirationDate.getTime()
  const timeNow = new Date().getTime()
  const twoMinutesInMS = 2 * 60 * 1000

  if (bearerExpirationTime <= timeNow + twoMinutesInMS) {
    console.log('%c bearer token is expired', 'color: #0000ff')
    await store.dispatch('getBearerToken')
  }
  waitingForserverResonse = false
}



// WEBPACK FOOTER //
// ./src/services/http-common.js